(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hub-needs-compact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialiseNeeds(root) {
      if (!root || root.dataset.hubNeedsReady === 'true') return;
      const buttons = Array.from(root.querySelectorAll('[data-hub-needs-tier]'));
      const panels = Array.from(root.querySelectorAll('[data-hub-needs-panel]'));
      const status = root.querySelector('[data-hub-needs-status]');
      if (buttons.length !== 5 || panels.length !== 5) return;
      function selectTier(tier, announce) {
        buttons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.hubNeedsTier === tier));
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.hubNeedsPanel !== tier;
        });
        if (announce && status) {
          const selected = buttons.find((button) => button.dataset.hubNeedsTier === tier);
          status.textContent = selected.querySelector('[data-hub-needs-label]').textContent.trim();
        }
      }
      buttons.forEach((button) => {
        button.disabled = false;
        button.addEventListener('click', () => selectTier(button.dataset.hubNeedsTier, true));
      });
      root.dataset.hubNeedsReady = 'true';
      selectTier('1', false);
    }
    function initialiseAll(scope) {
      if (scope.matches && scope.matches('[data-hub-needs]')) initialiseNeeds(scope);
      scope.querySelectorAll('[data-hub-needs]').forEach(initialiseNeeds);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll(document), { once: true });
    } else {
      initialiseAll(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hub-review-collage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialiseReviewCollage(root) {
      if (!root || root.dataset.hubReviewReady === 'true') return;
      const dialog = root.querySelector('[data-hub-review-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const image = dialog.querySelector('[data-hub-review-full-image]');
      const heading = dialog.querySelector('[data-hub-review-dialog-heading]');
      const transcript = dialog.querySelector('[data-hub-review-transcript]');
      const scroll = dialog.querySelector('[data-hub-review-image-scroll]');
      const close = dialog.querySelector('[data-hub-review-close]');
      if (!image || !heading || !transcript || !scroll || !close) return;
      let lastTrigger = null;
      root.querySelectorAll('[data-hub-review-zoom]').forEach((link) => {
        link.setAttribute('aria-haspopup', 'dialog');
        link.addEventListener('click', (event) => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const original = link.querySelector('img');
          if (!original) return;
          event.preventDefault();
          lastTrigger = link;
          image.src = link.href;
          image.alt = original.alt;
          image.width = original.naturalWidth || Number(original.getAttribute('width'));
          image.height = original.naturalHeight || Number(original.getAttribute('height'));
          heading.textContent = link.dataset.hubReviewTitle;
          transcript.textContent = original.alt;
          dialog.showModal();
          scroll.scrollLeft = 0;
        });
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (lastTrigger && lastTrigger.isConnected) lastTrigger.focus();
      });
      root.dataset.hubReviewReady = 'true';
    }
    function initialiseAllReviewCollages() {
      document.querySelectorAll('[data-hub-review-collage]').forEach(initialiseReviewCollage);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAllReviewCollages);
    else initialiseAllReviewCollages();
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches && event.target.matches('[data-hub-review-collage]')) initialiseReviewCollage(event.target);
      event.target.querySelectorAll('[data-hub-review-collage]').forEach(initialiseReviewCollage);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
